import { useEffect, useState } from "react"
import { sendExtensionMessage } from "@web/components/CreateVacancyForm/CreateVacancyForm.utils"
import { BrowserMessageType } from "platform-common/types"

export const useChromeExtensionState = () => {
  const [isInstalled, setIsInstalled] = useState<boolean>()

  useEffect(function checkIfChromeExtensionInstalled() {
    const pingChromeExtension = async () => {
      const response = await sendExtensionMessage(BrowserMessageType.Ping)
      const isInstalled = !!response && response.type === BrowserMessageType.Pong
      setIsInstalled(isInstalled)
    }
    pingChromeExtension().catch(console.error)
  }, [])

  return {
    isInstalled,
    isLoading: isInstalled === undefined,
  }
}
